import {url} from "./BaseUrl";
import {useEffect, useState} from "react";
import React from "react";
import axios from "axios";
import "./style.css"; // Import your CSS file
const tele = window.Telegram.WebApp;
tele.expand();
function Admins(){
    const [isLoading, setIsLoading] = useState(false); // State for loading indicator
    const [admins, setAdmins] = useState([]);
    const user = tele.initDataUnsafe?.user?.username;

    //console.log(admins)
    async function getAdmins() {
        setIsLoading(true);
        try {
            await axios.get(url+'/admins', {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                .then((res) => {
                    setAdmins(res.data);
                })
        }catch (error) {
            console.log(error);
        }finally {
            setIsLoading(false);
        }

    }useEffect(() => {
        getAdmins();
    }, []);

    const [searchText,setSearchText] = useState("");
    const handleSearch = (value) => {
        setSearchText(value);
    }

    const handleRemoveAdmin = async (index) => {
        if(window.confirm('Are you sure you want to delete this admin?')){
            try {
                await axios.delete(url+`/remove/${index}`, {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                    .then((res => {
                        if(res.data ==="exist")
                            alert("تم حدف أدمن بالفعل")
                        else
                            alert("تم حدف أدمن بنجاح")
                        getAdmins();
                    }));
            } catch (error) {
                console.error(error);
            }
        }

    };
    const handlesearchChange = (event) => {
        setSearchText(event.target.value);
        const filteredUsers = admins.filter(admin =>  {
            const userName = admin.user_name?.toLowerCase() || '';
            const chatId = admin.chat_id?.toString()?.toLowerCase() || '';
            const firstName = admin.first_name || '';
            const lastName = admin.last_name || '';
            // Assuming you've handled Arabic character encoding and normalization
            return userName.includes(searchText.toLowerCase()) ||
                chatId.includes(searchText.toLowerCase()) ||
                firstName.includes(searchText) ||
                lastName.includes(searchText);
        });
        // if (searchText === '' ) {
        //     setSearchText('');
        //     setAdmins(admins.slice()); // Create a shallow copy of admins
        // } else {
            // Update editing user index based on the filtered results
            const matchingUserIndex = filteredUsers.findIndex(user => user.chat_id === (editingUserIndex !== null ? admins[editingUserIndex].chat_id : null));
            setEditingUserIndex(matchingUserIndex !== -1 ? matchingUserIndex : null);
            setAdmins(filteredUsers);
        // }
        // const matchingUserIndex = filteredUsers.findIndex(user => user.chat_id === (editingUserIndex !== null ? admins[editingUserIndex].chat_id : null)); // Check for existing editing user
        // setEditingUserIndex(matchingUserIndex !== -1 ? matchingUserIndex : null); // Update editing index if found
        // setAdmins(filteredUsers);
    }


    const [editingUserIndex, setEditingUserIndex] = useState(null);
    const [editedUserData, setEditedUserData] = useState({}); // State for edited user data

    const handleEditClick = (index) => {
        setEditingUserIndex(index);
        setEditedUserData({ // Pre-fill with existing data
            ...admins[index],
        });
    };

    const handleSave = async (chat_id) => {
        try {
            const updatedUser = {
                ...admins[chat_id], // Copy the original user object
                role: editedUserData.role,
            };
            await axios.put(url+`/update_admin/${chat_id}`, updatedUser,{headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}});
            const updatedUsers = [...admins];
            const indexToUpdate = updatedUsers.findIndex(user => user.chat_id === chat_id);

            if (indexToUpdate !== -1) {
                updatedUsers[indexToUpdate] = {
                    ...updatedUsers[indexToUpdate],
                    role: editedUserData.role
                };
            }
            setAdmins(updatedUsers);
            setEditingUserIndex(null); // Stop editing
        } catch (error) {
            console.error(error);
        }
    };
    console.log(editedUserData)

    return(
        <>
            <div className="content-center flex flex-row justify-between w-auto mt-2 h-auto">
                <div className="bg-gradient-to-b from-sky-500 to-indigo-500 shadow-xl shadow-indigo-500/40 rounded-b mx-auto w-full">
                    <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                        <h1 className="text-lg font-bold text-gray-900 text-right">
                            مرحباَ بك يا <span className="text-lg font-bold text-gray-900 text-right mr-2">{user}</span>
                        </h1>
                    </div>
                    <div className="p-2 md:px-8 flex justify-start  m-4" dir={"rtl"}>
                        <input type="text"
                               className="border-solid border-2 rounded-md w-1/3 max-sm:w-2/3 px-2 py-1"
                               placeholder="بحث عن اسم المستخدم"
                               onChange={handlesearchChange}
                               value={searchText} />
                    </div>
                    <div className="p-2 md:px-8 justify-center m-4 mb-6 bg-white rounded-xl">
                        {isLoading ? (
                            <div className="flex items-center justify-center"> {/* Center the content horizontally */}
                                <img className="w-12 h-12 animate-spin mr-4" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" /> {/* Add margin for spacing */}
                                <span className="text-xl font-bold">جاري التحميل...</span>
                            </div>
                        ):(
                            <table className="w-full text-md bg-white shadow-md rounded mb-4 table-fixed " dir="rtl">
                                <thead className="flex flex-col items-center   w-full pl-4">
                                <tr className="border-b text-center justify-between flex w-full  mb-4">
                                    <th className="p-3 w-1/8">#</th>
                                    <th className="p-3 w-1/4">رمز المستخدم</th>
                                    <th className="p-3 w-1/4">اسم المستخدم</th>
                                    <th className="p-3 w-1/4 max-sm:hidden">اسم أول</th>
                                    <th className="p-3 w-1/4 max-sm:hidden">اسم اخير</th>
                                    <th className="p-3 w-1/4">صفة</th>
                                    <th className="p-3 w-1/5">فعل</th>
                                </tr>
                                </thead>
                                <tbody className="flex flex-col items-center  overflow-y-scroll h-auto max-h-96 w-full pl-3">
                                {(admins.filter(admin =>  {
                                    const userName = admin.user_name?.toLowerCase() || '';
                                    const chatId = admin.chat_id?.toString()?.toLowerCase() || '';
                                    const firstName = admin.first_name || '';
                                    const lastName = admin.last_name || '';

                                    // Assuming you've handled Arabic character encoding and normalization
                                    return userName.includes(searchText.toLowerCase()) ||
                                        chatId.includes(searchText.toLowerCase()) ||
                                        firstName.includes(searchText) ||
                                        lastName.includes(searchText);
                                })

                                    .map((admin,index)=>(
                                        <tr className="text-center hover:bg-orange-100 flex w-full  justify-between mb-4"  key={admin.chat_id} >
                                            <td className="p-3 w-1/8 flex items-center justify-center">{index+1}</td>
                                            <td className="p-3 w-1/4 flex items-center justify-center">{admin.chat_id}</td>
                                            <td className="p-3 w-1/4 items-center justify-center font-medium" dir={'ltr'}>
                                                @{admin.user_name}
                                                <dl className={'lg:hidden'}>
                                                    <dt className={'sr-only'}>اسم أول والأخير</dt>
                                                    <dd className={"text-gray-600"}>{admin.first_name} {admin.last_name}</dd>
                                                </dl>
                                            </td>
                                            <td className="p-3 w-1/4 flex items-center justify-center max-sm:hidden">{admin.first_name}</td>
                                            <td className="p-3 w-1/4 flex items-center justify-center max-sm:hidden">{admin.last_name}</td>
                                            <td className="p-3 w-1/4 flex items-center justify-center">
                                                {editingUserIndex === index ? (
                                                        <input type="text" className={'w-full'} name='role' value={editedUserData.role }
                                                               onChange={(e) =>
                                                                   setEditedUserData({ ...editedUserData, role: e.target.value,})}/>
                                                    // <input type="text" className={'w-full text-black'} name="role" value={editedUserData.role}
                                                    //        onChange={(e) =>
                                                    //            setEditedUserData({ ...editedUserData, role: e.target.value,})}/>
                                                ):(<>{admin.role}</>)}
                                            </td>
                                            <td className="p-3 w-1/4 flex flex-col items-center justify-center">
                                                {admin.role !== 'super' &&
                                                    (editingUserIndex !== index ? (
                                                        <>
                                                            <button className="bg-blue-500 hover:bg-blue-700 text-white rounded p-2"
                                                                    onClick={() => handleEditClick(index)}>
                                                                تعديل
                                                            </button>
                                                             <button className="bg-red-500 hover:bg-red-700 text-white  p-2 rounded"
                                                                         onClick={() => handleRemoveAdmin(admin.chat_id)}>حذف</button>
                                                        </>
                                                    ):(
                                                        <>
                                                            <button className="bg-green-500 hover:bg-green-700 text-white rounded p-2"
                                                                    onClick={() => handleSave(admin.chat_id)}>
                                                                حفظ
                                                            </button>
                                                            <button  className="bg-red-500 hover:bg-red-700 text-white rounded p-2"
                                                                     onClick={() => setEditingUserIndex(null)}>
                                                                إلغاء
                                                            </button>
                                                        </>
                                                    ))
                                                }
                                            </td>
                                        </tr>
                                    )))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </>
    );

}

export default Admins